<template>
  <div>
    <!-- 关于我们 -->
    <section id="about" class="d-flex align-items-center" data-aos="fade-up">
      <img src="@/assets/img/common/about/aboutUs.png"  class="image-width-100"/>
    </section>
    <!-- 选择火神信息 -->
    <section id="choiceHs" class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <div class="row pt-3">
          <div class="col-lg-3 col-md-12 col-12 text-align-center">
            <h1 class="title-main font-weight-bold pb-2">为什么选择火神信息？</h1>
            <span class="display-inline-block pb-2 title-sub text-line-height-1">以结果为导向,应你所需,不负所望</span>
            <div class="text-align-left">
              <span class="indentation display-inline-block pb-3 text-line-height-1">
                武汉火神信息科技有限公司（以下简称“火神信息” 是一家2016年成立于武汉光谷的创新型软件服务企业,
                已经成功为多家台资,民营,美资企业实现信息化和云服务项目。
              </span>
              <span class="indentation display-inline-block pb-3 text-line-height-1">
                创始人 - 谢波 : 技术宅,项目经理,曾供职于EDS,HP等外资公司服务过的项目客户大陆航空,GM,P&G。
              </span>
              <span class="indentation display-inline-block pb-3 text-line-height-1">
                 火神信息以“服务企业,交付信任”为宗旨，致力于帮助客户提升核心价值。根据客户的不同需求,提供人员外包服务,项目外包服务等,从而实现与客户的合作共赢。
                 公司已通过2019年高新企业和小巨人评审。
              </span>
            </div>
          </div>
          <div class="col-lg-9 col-md-12 col-12">
            <picture>
              <source media="(max-width: 768px)" srcset="@/assets/img/md/about/choice.png">
              <source media="(min-width: 768px)" srcset="@/assets/img/lg/about/choice.png">
              <img src="@/assets/img/lg/about/choice.png"  class="image-width-100"/>
            </picture>
          </div>
        </div>
        <div class="row pt-4 hs-info-style">
          <div class="col-lg-3 col-md-6 col-6" v-for="(item, index) in chooseList" :key="'choose'+index">
            <img :src="item.src"><br />
            <span class="title-name font-weight-bold display-inline-block pt-3">{{item.title}}</span><br />
            <span class="title-desc display-inline-block pt-2 pb-3 text-line-height-2">{{item.describe}}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业文化 -->
    <section id="culture" class="pt-4 pb-4 fff-background" data-aos="fade-up">
      <div class="text-align-center lg-hidden">
        <h1 class="title-main font-weight-bold pb-2">企业文化</h1>
        <p class="title-sub pb-3">corporate culture</p>
      </div>
      <div class="col">
        <picture>
          <source media="(max-width: 768px)" srcset="@/assets/img/md/about/culture.png">
          <source media="(min-width: 768px)" srcset="@/assets/img/lg/about/culture.png">
          <img src="@/assets/img/lg/about/culture.png"  class="image-width-100"/>
        </picture>
      </div>
    </section>
    <!-- 公司资质 -->
    <section id="qualifications" class="d-flex align-items-center pt-4 pb-4 fff-background" data-aos="fade-up">
      <div class="container">
        <div class="text-align-center">
          <h1 class="title-main font-weight-bold pb-3">公司资质</h1>
        </div>
        <div class="row text-align-center">
          <div class="col">
            <img src="@/assets/img/common/company/certificate.png"  class="image-width-100"/>
            <span class="title-sub display-inline-block mt-1">高新技术企业证书</span>
          </div>
          <div class="col">
            <img src="@/assets/img/common/company/license.png"  class="image-width-100"/>
            <span class="title-sub display-inline-block mt-1">营业执照</span>
          </div>
        </div>
        <div class="row pt-4">
          <div class="testimonials-slider swiper" data-aos="fade-up" data-aos-delay="100">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in bannerList" :key="'banner'+index">
                <img :src="item.src"  class="image-width-100" />
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- 定制服务 -->
    <section id="custom" class="pt-4 pb-4"  data-aos="fade-up">
      <div class="lg-hidden">
        <h1 class="title-h1 font-weight-bold text-align-center pb-2">项目定制服务</h1>
        <p class="title-h2 text-align-center pb-3">Customization Service</p>
      </div>
      <picture>
        <source media="(max-width: 768px)" srcset="@/assets/img/md/about/custom.png">
        <source media="(min-width: 768px)" srcset="@/assets/img/lg/about/custom.png">
        <img src="@/assets/img/lg/about/custom.png"  class="image-width-90"/>
      </picture>
    </section>
    
    <!-- 公司风采 -->
    <!-- <section id="demeanor" class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <div class="text-align-center">
          <h1 class="title-main font-weight-bold pb-2">公司风采</h1>
          <p class="title-sub pb-3">激情创造,共同成长</p>
        </div>
        <div class="row">
          <div class="col">
            <img src="@/assets/img/common/about/elegantDemeanor.png"  class="image-width-100"/>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.min.js'
export default {
  name: 'Header',
  components: {},
  props: {},
  data() {
    return {
      bannerList: [
        {
          src: require('@/assets/img/common/companyBanner/banner1.png'),
        },
        {
          src: require('@/assets/img/common/companyBanner/banner1.png'),
        },
        {
          src: require('@/assets/img/common/companyBanner/banner1.png'),
        }
      ],
      // 选择火神信息
      chooseList: [
        {
          src: require('@/assets/img/common/choose/choose1.png'),
          title: '更短的开发周期',
          describe: '快速的产品设计响应并依赖自主框架， 避免重复造轮子，极大缩短开发时间'
        },
        {
          src: require('@/assets/img/common/choose/choose2.png'),
          title: '更持续的投资回报',
          describe: '通过不断的持续迭代和升级最大程度的 保护您的投资收益'
        },
        {
          src: require('@/assets/img/common/choose/choose3.png'),
          title: '更高的产品质量',
          describe: '团队成熟，产品稳定，快速有效开 发，实现高质量产品'
        },
        {
          src: require('@/assets/img/common/choose/choose4.png'),
          title: '更好的安全性能',
          describe: '充分考虑产品和项目的合规性，最大程度的 减少系统漏洞并帮助客户完善安全策略'
        }
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {
  },
  created() {
  },
  mounted () {
    new Swiper('.testimonials-slider', {
      speed: 600,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      slidesPerView: 3,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      }
    });
  },
}
</script>
<style scoped>
</style>
